import { AppKind } from '@core/tellent-types';

const validAppKinds = Object.values(AppKind);

const isValidAppKind = (kind: AppKind | string): kind is AppKind =>
  validAppKinds.includes(<any>kind);

export class AppKindNotRecognizedError extends Error {
  public url: URL;
  constructor(url: URL) {
    super(
      `AppKind not found or is not valid.\n
      Valid kinds are: ${validAppKinds.join(', ')}
      URL was: ${url.toString()}, expected: ${url.origin}/.../{${validAppKinds.join('|')}}/\n`,
    );

    this.url = url;
  }
}

export const readBootstrapDataFromUrl = (url: string): { appKind: AppKind; baseHref: string } => {
  const urlObj = new URL(url);
  const pathname = urlObj.pathname;

  const pathSegments = pathname.split('/').filter(segment => segment !== '');

  let appKindIndex = -1;
  let appKind: AppKind | undefined;

  for (let i = 0; i < pathSegments.length; i++) {
    if (isValidAppKind(pathSegments[i])) {
      appKind = <AppKind>pathSegments[i];
      appKindIndex = i;
      break;
    }
  }

  if (!appKind || appKindIndex === -1) {
    throw new AppKindNotRecognizedError(urlObj);
  }

  const baseHref = '/' + pathSegments.slice(0, appKindIndex + 1).join('/') + '/';

  return {
    appKind,
    baseHref,
  };
};
